(function () {
  'use strict';

  // Hoppy Currency renders the store currency with its generic symbol (MDL -> "200.00L").
  // Its currency table is assigned to this global by a deferred script that runs after
  // this one, so the store currency symbol is patched at assignment time.
  var script = document.currentScript;
  var shopCurrency = script && script.dataset.shopCurrency;
  if (!shopCurrency) return;

  var table;
  try {
    Object.defineProperty(window, 'futureBlink_currencies', {
      configurable: true,
      get: function () { return table; },
      set: function (value) {
        if (value && value[shopCurrency]) {
          value[shopCurrency].symbol = ' ' + shopCurrency;
          value[shopCurrency].symbolNative = ' ' + shopCurrency;
        }
        table = value;
      }
    });
  } catch (e) {}
})();
